import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { RouterModule } from '@angular/router';

import { AUTH_MANAGER, loginSuccess } from '@asset-solutions/customer-portal/auth/data-access';
import { ColorMode } from '@asset-solutions/shared/ui';
import { NotificationService } from '@asset-solutions/shared/utilities';
import { Store } from '@ngrx/store';
import { OAuthProvider } from 'firebase/auth';

import { SplashPageComponent } from '../splash-page.component';

@Component({
  selector: 'auth-login',
  imports: [RouterModule, FormsModule, MatInputModule, MatButton, SplashPageComponent],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoginComponent {
  private readonly authManager = inject(AUTH_MANAGER);
  private readonly notificationService = inject(NotificationService);
  private readonly store = inject(Store);
  protected readonly colorMode = inject(ColorMode);

  protected emailAddress = '';
  protected password = '';

  protected loginEmail(): void {
    if (this.emailAddress.endsWith('@crst.com')) {
      this.notificationService.default('If you work for CRST, use the employee login button below');
      return;
    }
    if (this.emailAddress && this.password) {
      this.authManager
        .signInWithEmailAndPassword(this.emailAddress, this.password)
        .then((token) => this.store.dispatch(loginSuccess({ token })))
        .catch(() => this.notificationService.error('Invalid email or password'));
    }
  }

  protected loginEmployee(): void {
    const provider = new OAuthProvider('microsoft.com');

    this.authManager
      .signInWithPopup(provider)
      .then((token) => this.store.dispatch(loginSuccess({ token })))
      .catch(() => this.notificationService.error('Active Directory seems to be unavailable'));
  }
}
